import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate, CanActivateChild {
  constructor(private _router: Router, private _loginservice: LoginService) { }
  canActivate() {
    if (this._loginservice.getLoggedInUser()) {
      return true;
    } else {
      this._router.navigate(['/login']);
      return false;
    }
  }
  canActivateChild() {
    const login = this._loginservice.getLoggedInUser();
    if (login) {
      if (login.usertype == 'Agent' || login.usertype == 'AGENT' || login.usertype == 'DEP' || login.usertype == 'dept') {
        const route1 = this._loginservice.getNavigationAgent();
        // console.log(route1);
        const url = this._router.getCurrentNavigation().finalUrl;
        // console.log(url.toString());

        if (route1 != null) {
          for (let i = 0; i < route1.length; i++) {
            if (url.toString().indexOf(route1[i]) !== -1) {
              return true;
            }
          }
        }
      }
      if (login.usertype == 'ADMIN') {
        const route2 = this._loginservice.getNavigationAdmin();
        // console.log(route2);
        const url = this._router.getCurrentNavigation().finalUrl;
        // console.log(url);
        if (route2 != null) {
          for (let i = 0; i < route2.length; i++) {
            if (url.toString().indexOf(route2[i]) !== -1) {
              return true;
            }
          }
        }
      }
    } else {
      this._router.navigate(['/login']);
      return false;
    }
  }

}
